import {getJson, postJson, patchJson} from '@/util/ajaxUtils';

export function doLogin({username, password, corpId, captchaKey, captchaText}) {
    return postJson('/auth/login', {
        custom: {noAuth: true, throwError: true, showErrorNotification: false},
        params: {username, password, corpId, captchaKey, captchaText},
    });
}

export function doProfile(userId) {
    return getJson('/auth/profile', {params: {userId}});
}

export function doLogout(config) {
    return postJson('/auth/logout', {
        custom: {noAuth: true, throwError: true, showErrorNotification: false},
        ...config,
    });
}

/**
 * 修改用户密码。
 *
 * @param userId
 * @param data 格式为 {origPass, password}
 * @return {Promise<*>}
 */
export function doResetPassword(userId, data) {
    return patchJson('/auth/profile/pass-reset', {params: {userId}, data});
}

export function getCaptcha() {
    return getJson('/open/captcha', {custom: {noAuth: true}});
}

export function passResetRequest(params) {
    return postJson('/password-reset/request', {params, custom: {noAuth: true}});
}

export function passResetCheck(email, code) {
    return getJson('/password-reset/request-check', {
        params: {email, code},
        custom: {
            showErrorNotification: false,
            throwError: true,
            noAuth: true,
        },
    });
}

export function passReset(data) {
    return postJson('/password-reset/reset', {data, custom: {noAuth: true}});
}

export function usercorps(username) {
    return getJson('/auth/usercorps', {params: {username}});
}

export function switchCorp(userId, corpId) {
    return getJson('/auth/switchcorp', {params: {userId, corpId}});
}
